<template>
  <div class="home">
    <h1 class="headline center">v-m-blog</h1>
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <div class="sections">
      <div
        v-for="(section, index) in Object.keys(entries)"
        :key="index"
        class="group"
      >
        <h2 class="center">{{ section }}</h2>
        <div class="section" v-for="entry in entries[section]" :key="entry.id">
          <div class="entry">
            <div class="entry-date">{{ entry.date }}</div>
            <h3 @click="$router.push({ name: entry.id })">
              {{ entry.title }}
            </h3>
            <p>{{ entry.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BLOGENTRIES from '@/statics/data/blogs.json'

export default {
  name: 'IndexBlog',
  computed: {
    entries() {
      return BLOGENTRIES
    }
  }
}
</script>
<style lang="scss" scoped>
.center {
  text-align: center;
}
.headline {
  text-transform: uppercase;
  margin: 4rem auto;
  font-size: 4rem;
}
img {
  display: block;
  margin: 0 auto;
  width: 150px;
}

h3 {
  // color: #42b883;
  margin-bottom: 0;
  cursor: pointer;
  font-family: Roboto, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 400;
  letter-spacing: 0.03125em;
  text-decoration: inherit;
  text-transform: inherit;
  color: #212121;
  margin: 0;
  letter-spacing: 0;
  text-decoration: underline;
  font-weight: bold;
  font-size: 1rem;
  &:hover {
    text-decoration: underline;
  }
}

.entry-date {
  font-family: 'Roboto Mono', monospace;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0;
  text-decoration: none;
  text-transform: uppercase;
  margin-top: 1.5rem;
  margin-bottom: 0.25rem;
  color: #616161;
  margin: 24px 16px 4px 0;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.25rem;
}

p {
  margin-top: 0.4rem;
}

.sections {
  max-width: 40vw;
  margin: 0 auto;
  margin-top: 4rem;
}

.section {
  margin-bottom: 3rem;
}

.group {
  margin-bottom: 4rem;
}
</style>
